"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";
import { useFlipCard } from "./useFlipCard";
import type { PartnerConfig } from "./partners.config";
export function GenericPartnerCard(t0) {
  const $ = _c(68);
  const {
    id,
    shape,
    logoSrc,
    cardSrc,
    email,
    phone
  } = t0;
  const {
    isFlipped,
    toggle
  } = useFlipCard(5000);
  const [copySuccess, setCopySuccess] = React.useState(false);
  const t = useTranslations(`contact.partners.${id}`);
  let t1;
  let t2;
  if ($[0] !== copySuccess) {
    t1 = () => {
      if (!copySuccess) {
        return;
      }
      const timer = setTimeout(() => setCopySuccess(false), 2000);
      return () => clearTimeout(timer);
    };
    t2 = [copySuccess];
    $[0] = copySuccess;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] !== email) {
    t3 = async e => {
      e.stopPropagation();
      ;
      try {
        await navigator.clipboard.writeText(email);
        setCopySuccess(true);
      } catch (t4) {
        const err = t4;
        console.error("Erreur lors de la copie de l'email:", err);
      }
    };
    $[3] = email;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCopyEmail = t3;
  const t4 = isFlipped ? "z-50" : "z-0";
  let t5;
  if ($[5] !== t4) {
    t5 = clsx("group relative w-32 h-32 md:w-40 md:h-40 [perspective:1000px] cursor-pointer transition-all duration-500", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("clickToFlip");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = isFlipped && "[transform:rotateY(180deg)_scale(2)]";
  let t8;
  if ($[9] !== t7) {
    t8 = clsx("relative w-full h-full transition-all duration-700 [transform-style:preserve-3d]", t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = shape === "round" ? "rounded-full p-6" : "rounded-xl p-4";
  let t10;
  if ($[11] !== t9) {
    t10 = clsx("absolute inset-0 [backface-visibility:hidden] bg-white-cream/50 border border-forest-green/5 flex items-center justify-center overflow-hidden group-hover:bg-white-cream transition-colors shadow-sm", t9);
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t) {
    t11 = t("alt");
    $[13] = t;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== logoSrc || $[16] !== t11) {
    t12 = <div className="relative w-full h-full"><Image src={logoSrc} alt={t11} fill={true} sizes="(max-width: 768px) 100vw, 300px" className="object-contain" /></div>;
    $[15] = logoSrc;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = isFlipped ? "opacity-0" : "opacity-0 group-hover:opacity-100";
  let t14;
  if ($[18] !== t13) {
    t14 = clsx("absolute inset-0 bg-forest-green/5 flex items-center justify-center transition-opacity duration-300", t13);
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t) {
    t15 = t("viewContact");
    $[20] = t;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t15) {
    t16 = <span className="text-[10px] font-medium text-forest-green bg-white/90 px-2 py-1 rounded-full shadow-sm">{t15}</span>;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t14 || $[25] !== t16) {
    t17 = <div className={t14}>{t16}</div>;
    $[24] = t14;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t10 || $[28] !== t12 || $[29] !== t17) {
    t18 = <div className={t10}>{t12}{t17}</div>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  const t19 = shape === "round" ? "rounded-xl flex items-center justify-center p-2" : "rounded-xl";
  let t20;
  if ($[31] !== t19) {
    t20 = clsx("absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] bg-white shadow-lg overflow-hidden border border-forest-green/10 transition-shadow cursor-pointer group/email", t19);
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t) {
    t21 = t("copyEmail");
    $[33] = t;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t) {
    t22 = t("cardAlt");
    $[35] = t;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== cardSrc || $[38] !== t22) {
    t23 = <Image src={cardSrc} alt={t22} fill={true} sizes="(max-width: 768px) 100vw, 300px" className="object-cover" />;
    $[37] = cardSrc;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  const t24 = copySuccess ? "opacity-100 translate-y-0" : "opacity-0 group-hover/email:opacity-100 translate-y-4 group-hover/email:translate-y-0";
  let t25;
  if ($[40] !== t24) {
    t25 = clsx("bg-white/90 text-forest-green text-[10px] font-medium px-2 py-1 rounded-full shadow-sm transform transition-all duration-300", t24);
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== copySuccess || $[43] !== t) {
    t26 = copySuccess ? t("emailCopied") : t("copyEmail");
    $[42] = copySuccess;
    $[43] = t;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== t25 || $[46] !== t26) {
    t27 = <span className={t25}>{t26}</span>;
    $[45] = t25;
    $[46] = t26;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== phone) {
    t28 = phone && <a href={`tel:${phone.replace(/\\s+/g, "")}`} onClick={_temp} className="opacity-0 group-hover/email:opacity-100 translate-y-4 group-hover/email:translate-y-0 bg-white/95 text-forest-green text-[12px] font-bold px-3 py-1.5 rounded-full shadow-md transform transition-all duration-300 hover:scale-105 hover:bg-white flex items-center gap-1.5">📞 {phone}</a>;
    $[48] = phone;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t27 || $[51] !== t28) {
    t29 = <div className="absolute inset-0 z-20 bg-black/0 hover:bg-black/5 transition-colors flex flex-col gap-2 items-center justify-center">{t27}{t28}</div>;
    $[50] = t27;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== handleCopyEmail || $[54] !== t20 || $[55] !== t21 || $[56] !== t23 || $[57] !== t29) {
    t30 = <div onClick={handleCopyEmail} className={t20} title={t21}>{t23}{t29}</div>;
    $[53] = handleCopyEmail;
    $[54] = t20;
    $[55] = t21;
    $[56] = t23;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t18 || $[60] !== t30 || $[61] !== t8) {
    t31 = <div className={t8}>{t18}{t30}</div>;
    $[59] = t18;
    $[60] = t30;
    $[61] = t8;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t31 || $[64] !== t5 || $[65] !== t6 || $[66] !== toggle) {
    t32 = <div className="flex flex-col items-center gap-4"><div className={t5} onClick={toggle} title={t6}>{t31}</div></div>;
    $[63] = t31;
    $[64] = t5;
    $[65] = t6;
    $[66] = toggle;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  return t32;
}
function _temp(e_0) {
  return e_0.stopPropagation();
}